/* @flow */

import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AccountHistory from 'app/scenes/account/AccountHistory';
import AccountBonus from 'app/scenes/account/AccountBonus';
import AccountLimits from 'app/scenes/account/AccountLimits';
import AccountMenu from 'app/components/user/AccountMenu';
import AccountProfile from 'app/scenes/account/AccountProfile';
import AccountProfilePxc from 'app/scenes/account/AccountProfilePxc';
import AccountSelfExclusion from 'app/scenes/account/AccountSelfExclusion';
import AccountTakeABreak from 'app/scenes/account/AccountTakeABreak';
import AccountTransactions from 'app/scenes/account/AccountTransactions';
import AccountSettings from 'app/scenes/account/AccountSettings';
import Page from 'app/containers/parts/Page';
import UserOnly from 'app/components/util/UserOnly';
import Withdraw from 'app/scenes/account/Withdraw';

type Props = {
  enableAccountLimit: boolean,
  isActive?: boolean,
  isFreeOnly?: boolean,
  isPxcEnabled?: boolean
};

const defaultProps = {
  isActive: false,
  isFreeOnly: false,
  isPxcEnabled: false
};

function Account({ enableAccountLimit, isActive, isFreeOnly, isPxcEnabled }: Props) {
  return (
    <UserOnly>
      <Page>
        {/* <AccountMenu
          enableAccountLimit={enableAccountLimit}
          isActive={isActive}
          isFreeOnly={isFreeOnly}
          isPxcEnabled={isPxcEnabled}
        /> */}
        <Switch>
          <Route exact path="/account">
            {!isPxcEnabled ? (
              <Redirect to="/account/profile" />
            ) : (
              <Redirect to="/account/history" />
            )}
          </Route>
          <Route
            path="/account/profile"
            component={isPxcEnabled ? AccountProfilePxc : AccountProfile}
          />
          <Route path="/account/history" component={AccountHistory} />
          <Route path="/account/bonus" component={AccountBonus} />
          {!isFreeOnly && <Route path="/account/withdraw" component={Withdraw} />}
          {!isFreeOnly && (
            <Route path="/account/transactions/:type?" component={AccountTransactions} />
          )}
          {enableAccountLimit && <Route path="/account/limits" component={AccountLimits} />}
          {enableAccountLimit && (
            <Route path="/account/take-a-break" component={AccountTakeABreak} />
          )}
          {enableAccountLimit && (
            <Route path="/account/self-exclusion" component={AccountSelfExclusion} />
          )}
          <Route path="/account/settings" component={AccountSettings} />
        </Switch>
      </Page>
    </UserOnly>
  );
}

Account.defaultProps = defaultProps;

export default Account;
